__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "zaggle-portal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.100.10", () => (Promise.all([__webpack_require__.e(3083), __webpack_require__.e(8466), __webpack_require__.e(4750), __webpack_require__.e(8980)]).then(() => (() => (__webpack_require__(78980))))));
			register("framer-motion", "12.38.0", () => (Promise.all([__webpack_require__.e(3083), __webpack_require__.e(8466), __webpack_require__.e(4750), __webpack_require__.e(1959), __webpack_require__.e(1818), __webpack_require__.e(2872), __webpack_require__.e(6720), __webpack_require__.e(3845)]).then(() => (() => (__webpack_require__(17071))))));
			register("react-dom", "19.2.4", () => (() => (__webpack_require__(40961))), 1);
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(3083), __webpack_require__.e(8466), __webpack_require__.e(4750), __webpack_require__.e(1520), __webpack_require__.e(7732)]).then(() => (() => (__webpack_require__(132))))));
			register("react", "19.2.4", () => (() => (__webpack_require__(96540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};